import { useState } from 'react'
import clsx from 'clsx'

import { Button } from '@/ui/Button'
import { Popup } from '@/ui/Popup'
import { Checkbox } from '@/ui/Checkbox'
import { Input } from '@/ui/Input'
import { useGetGarages } from '@/modules/FindGarage/api/useGetGarages'
import { useGarageStore } from '@/modules/FindGarage'
import { sortRoutes } from '../../helpers/sortRoutes'

import styles from './RoutesFilter.module.scss'

import ChevronIcon from '../../assets/chevron-left.svg'

export const RoutesFilter = () => {
    const [search, setSearch] = useState('')
    const { garage: selectedGarage, selectedRoutes, setSelectedRoutes } = useGarageStore()
    const { data: garages = [] } = useGetGarages()

    const availableRoutes = sortRoutes(garages.flatMap((item) => item.routes))

    const options = availableRoutes.reduce<{ label: string; value: string; disabled: boolean }[]>(
        (acc, route) =>
            route.includes(search)
                ? [...acc, { label: route, value: route, disabled: !!selectedGarage?.routes.includes(route) }]
                : acc,
        []
    )

    const isClearActive = selectedRoutes.filter((route) => !selectedGarage?.routes.includes(route)).length

    const selectRoute = (route: string, notExcluded: boolean) => {
        if (notExcluded) {
            return
        }

        let updatedValues = [...selectedRoutes]

        if (selectedRoutes.includes(route)) {
            updatedValues = updatedValues.filter((item) => item !== route)
        } else {
            updatedValues.push(route)
        }

        setSelectedRoutes(updatedValues)
    }

    const clearValues = () => {
        if (!selectedGarage) {
            return
        }

        setSelectedRoutes(selectedGarage.routes)
    }

    const checkIsRowSelected = (route: string) => selectedRoutes.includes(route)

    return (
        <Popup
            triggerComponent={(open: boolean) => (
                <Button
                    rounded
                    variant="transparent"
                    size="small"
                    className={clsx(styles.trigger, { [styles.open]: open })}
                    disabled={!availableRoutes.length}
                >
                    Routes
                    <ChevronIcon />
                </Button>
            )}
            placement="bottom-start"
            className={styles.popup}
        >
            <div className={styles.container}>
                <div className={styles.searchInputWrapper}>
                    <Input
                        placeholder="Type to search for route"
                        value={search}
                        fullWidth
                        variant="large"
                        allowClear
                        onChange={(event) => setSearch(event.target.value)}
                    />
                </div>
                <div className={styles.scrollContainer}>
                    <div className={styles.optionsWrapper}>
                        <div className={styles.optionsActions}>
                            <p className={styles.selectedLabel}>{selectedRoutes.length} selected</p>
                            <button
                                className={clsx(styles.clear, {
                                    [styles.clearActive]: isClearActive,
                                })}
                                onClick={clearValues}
                            >
                                Clear
                            </button>
                        </div>
                        {options.map(({ label, value, disabled }) => (
                            <Button
                                key={value}
                                size="small"
                                variant="transparent"
                                onClick={() => selectRoute(value, disabled)}
                                className={styles.item}
                            >
                                <span>{label}</span>
                                <Checkbox
                                    variant="withoutLabel"
                                    checked={checkIsRowSelected(value)}
                                    disabled={disabled}
                                />
                            </Button>
                        ))}
                    </div>
                </div>
            </div>
        </Popup>
    )
}
